import { createContext, useContext } from 'react';

/** True when the builder is hosted inside another screen's dialog rather than on its own page. */
const EmbeddedBuilderContext = createContext(false);

export const EmbeddedBuilderProvider = EmbeddedBuilderContext.Provider;

export const useIsEmbeddedBuilder = () => useContext(EmbeddedBuilderContext);
